import { getRequest, postRequest } from 'utilities/service.utils';
import OriginalService from './orginal.service.context';

export const getFileFromUrl = async (url: string) => {
  return await getRequest(OriginalService, url, { responseType: 'blob' });
};

export const uploadFileToS3 = async (url: string, data: any) => {
  return await postRequest(OriginalService, url, data);
};
